export enum ChartActions {
  CHART_REQUEST = 'CHART_REQUEST',
  CHART_SUCCESS = 'CHART_SUCCESS',
  CHART_ERROR = 'CHART_ERROR',
  CHART_PROCESSING = 'CHART_PROCESSING',
}
